module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "full-width"
  }, [_c('h3', [_vm._v("Happy Customers")]), _vm._v(" "), _c('p', [_vm._v("\n        Since the inception of StumptheSpread.com we have valued the opinions\n        of our customers. We pride ourselves on going above and beyond when it\n        comes to customer service and guarantee we're the best in the industry\n        in that department. Below are handicapper reviews, customer comments\n        and customer reviews.\n      ")]), _vm._v(" "), _c('p', [_vm._v("Send us your comment to support@stumpthespread.com")]), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "6204371474",
      "ad-style": "display:inline-block;width:728px;height:90px",
      "ad-format": "auto"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.testimonials), function(test, index) {
    return _c('div', {
      key: test.id,
      staticClass: "colum one_half"
    }, [_c('blockquote', [_c('p', [_c('span', {
      staticClass: "dropcap"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n          " + _vm._s(test.content) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "sprite testimony-bg"
    }), _vm._v(" "), _c('cite', [_vm._v(_vm._s(test.author) + "  "), _c('b', [_vm._v(_vm._s(test.type))])])])], 1)
  }), _vm._v("\n    ';\n  ")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-69ac242e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Testimonials.vue
// module id = 509
// module chunks = 1